import { render } from "./ChatRoomCard.vue?vue&type=template&id=7d594bd2"
import script from "./ChatRoomCard.vue?vue&type=script&lang=js"
export * from "./ChatRoomCard.vue?vue&type=script&lang=js"
script.render = render

export default script